import classnames from 'classnames'
import { autoScrollChatToBottom } from 'modules/view/actions'
import { pathOr } from 'ramda'
import React, { useLayoutEffect, useMemo } from 'react'
import {useDispatch} from 'react-redux'

import './style.css'

interface UnfurlMessageProps {
  unfurlData: UnfurlData,
  style?: Record<string, any>,
  resolveMessageHeight?: () => void,
  sender: string
}

interface UnfurlData {
  html: string,
  meta?: Record<string, any>,

  url?: string,
  rel?: string[],
  links?: Record<string, any>
}

const UnfurlMessage = ({ unfurlData, style={}, resolveMessageHeight = () => {}, sender }: UnfurlMessageProps) => {
  const { html, meta = {}, links={}, url='', rel=[] }: UnfurlData = unfurlData
  const dispatch = useDispatch()


  useLayoutEffect(() => {
    resolveMessageHeight()
    dispatch(autoScrollChatToBottom(true))
  }, [resolveMessageHeight, html, dispatch])

  const hasRequiredMetadata = !!url && !!meta.title
  const hasOptionalMetadata = !!meta.description || !!meta.site
  const hasMetadata = hasRequiredMetadata && hasOptionalMetadata
  const thumbnail = pathOr(null, ['thumbnail', 0], links)
  const thumbnailAlt = pathOr(url, ['site'], meta)
  const primaryRel = rel[0]
  const isVideoCard = primaryRel === 'player'
  const isImageCard = !isVideoCard && thumbnail

  const hasRenderableContent = useMemo(() => (isImageCard || isVideoCard || hasMetadata), [isImageCard, isVideoCard, hasMetadata])

  if (!hasRenderableContent) {
    return null
  }

  return (
    <li className={`drift-widget-message drift-widget-message--unfurl drift-widget-message-sender--${sender}`}>
      <div className={classnames(`drift-widget-message--box drift-widget-message--unfurl-container`)} style={style}>
        { isVideoCard &&
          <div className="drift-widget-message--unfurl-video" dangerouslySetInnerHTML={{ __html: html }} />
        }
        { isImageCard &&
          <div className="drift-widget-message--unfurl-image">
            <a
              href={url}
              target="_blank"
              rel="nofollow noopener noreferrer"
              aria-label={`click to go to ${url}`}
              >
                <img alt={`${thumbnailAlt} - thumbnail`} src={thumbnail.href} onLoad={()=>{dispatch(autoScrollChatToBottom(true))}}/>
              </a>
          </div>
        }
        { hasMetadata &&
          <div className="drift-widget-message--unfurl_meta">
            { meta.title &&
              <h3 className="drift-widget-message--unfurl_title">
                <a rel="noopener noreferrer"
                  target="_blank" href={url}
                  title={meta.title}>
                    {meta.title}
                </a>
              </h3>
            }
            { meta.description &&
              <p className="drift-widget-message--unfurl_description">{meta.description}</p>
            }
            { meta.site &&
              <p className="drift-widget-message--unfurl_site">{meta.site}</p>
            }
          </div>
        }
      </div>
    </li>
  )
}

export default UnfurlMessage
